content-button {
  display: inline-block;
  > a, > button {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
  }
  > button {
    appearance: none;
    background: inherit;
    cursor: pointer;
  }

  &[clickable-block="true"] {
    display: block;
    width: 100%;
    height: 100%;
    > a,
    > button {
      height: 100%;
      width: 100%;
      > * {
        display: block;
        width: 100%;
      }
    }
    .content-button__clickable-content {
      width: 100%;
      height: 100%;
    }
  }

}